<template>
  <div class="topSearch ">
    <div class="topSearchBox width_1200 flex_a_c flex_j_sb">
      <div class="flex_a_c">
        <router-link to="/">
        <div class="flex_d_c flex_j_c gap_6">
          <img style="width: 65px;height: 32px;" src="@/assets/images/YYB_2.png" alt="">
          <span class="color_FE0505 fontS_12 lh_20">有有宝.COM</span>
        </div>
      </router-link>
        <div class="flex_a_c ml_140 gap_40" v-if="!isRouterAll.includes($route.path)">
          <div class="flex_a_c gap_3 cur_p">
            <el-popover placement="top-start" width="110" popper-class="merchantServices" trigger="hover">
              <div class="merchantServicesBox">
                <div v-for="(i,k) in homePageRoutes" :key="k">
                  <p class="color_584DFF_hover fontS_14" v-if="!i.hidden" @click="goRouter(i.path)">{{ i.meta.title }}</p>
                </div>
              </div>
              <div class="color_584DFF_hover" :class="activeMtd(homePageRoutes)" slot="reference" @click="goUserHome">
                首页
                <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>
          </div>
          <div class="flex_a_c gap_3 cur_p">
            <el-popover placement="top-start" width="100" popper-class="merchantServices" trigger="hover">
              <div class="merchantServicesBox">
                <div v-for="(i,k) in personRoutes" :key="k">
                  <p class="color_584DFF_hover fontS_14" v-if="!i.hidden" @click="goRouter(i.path)">{{ i.meta.title }}</p>
                </div>
              </div>
              <div class="color_584DFF_hover" slot="reference" :class="activeMtd(personRoutes)" @click="goUserBusinessCard">
                个人中心
                <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <div>
        <div>
          <el-input class="topSearchInput" placeholder="请输入内容" @keyup.enter.native="searchPro" v-model="keyword">
            <template slot="suffix">
              <el-button style="width: 98px;height: 31px;" type="primary" @click="searchPro">搜索</el-button>
            </template>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapMutations } from 'vuex'
import { homePageRoutes, personRoutes } from '@/router'

export default {
  name: 'topSearch',
  data () {
    return {
      keyword: '',
      homePageRoutes: homePageRoutes,
      personRoutes: personRoutes,
      isRouterAll: ['/customerService', '/evaluate', '/evaluateDetail', '/addEvaluate', '/orderDetail', '/afterSale'],
    }
  },
  created () {
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
      setHomePageRoutes: 'SET_HOMEPAGEROUTES',
      setPersonRoutes: 'SET_PERSONROUTES',
    }),
    // 查找
    searchPro () {
      if (!this.keyword) { return this.$message.error('请输入搜索内容') }
      this.setSearchObj({
          keyword: this.keyword,
          searchVal: '商品'
      })
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search',
        })
      }
    },
    // 跳转路由
    goRouter (path) {
      if (!path) return
      this.$router.push({ path: path })
    },
    // 路由的选择
    activeMtd (router) {
      return router.some(route => route.path === this.$route.path) ? 'isActive_584DFF' : ''
    },
    // 跳转个人首页
    goUserHome () {
      this.$router.push({ path: '/userHome' })
    },
    goUserBusinessCard () {
      // this.$router.push({ path: '/userBusinessCard' })
      this.$router.push({ path: '/userInfo' })
    }
  }
}
</script>

<style lang="scss">
.topSearch {
  width: 100%;
  background: #fff;
  height: 80px;

  .topSearchBox {
    height: 80px;
  }

  .topSearchInput {
    width: 400px;
    height: 32px;

    .el-input__inner {
      height: 32px;
    }

    .el-button {
      height: 32px;
    }

    .el-input__suffix {
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/topSearch.vue